import localhost, { downloadFileFromResponse } from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { resolvePeriod } from "utils/reportingPeriod";

import { selectFilters } from "./selectors";

const createExportThunk = (baseUrl, format, filename) =>
  () => async (dispatch, getState) => {
    try {
      const filters = selectFilters(getState());
      const { data } = await localhost.get(`${baseUrl}/export/${format}`, {
        responseType: "blob",
        params: resolvePeriod(filters),
      });
      downloadFileFromResponse(data, filename);
    } catch (err) {
      dispatch(showErrorModal(err));
    }
  };

export default createExportThunk;
